import { IVideo } from '@bridebook/models/source/models/Suppliers/Videos.types';

export function getVideoIframeUrl(video: IVideo, autoplay: boolean = true) {
  const id = video.sourceId;
  const type: IVideo['source'] = Array.isArray(video.source) ? video.source[0] : video.source;

  switch (type) {
    case 'youtube':
      return `https://youtube.com/embed/${id}${autoplay ? '?autoplay=1' : ''}`;
    case 'vimeo':
      return `https://player.vimeo.com/video/${id}${autoplay ? '?autoplay=1' : ''}`;
    case 'matterport':
    case 'googlemaps':
      return id;
    default:
      return '';
  }
}
